import { render, staticRenderFns } from "./MultiplePriceDetailsPopin.vue?vue&type=template&id=14010db5&scoped=true"
import script from "./MultiplePriceDetailsPopin.vue?vue&type=script&lang=ts"
export * from "./MultiplePriceDetailsPopin.vue?vue&type=script&lang=ts"
import style0 from "./MultiplePriceDetailsPopin.vue?vue&type=style&index=0&id=14010db5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14010db5",
  null
  
)

export default component.exports